import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import Loadable from 'react-loadable';
// import Chat from './../screens/Chat';
import ViewMail from './../screens/ViewMail';
import MailList from './../screens/MailList';
import Tutorial from './../screens/Tutorial';
import TutorialEnd from './../screens/TutorialEnd';
import Intro from './../screens/Intro'
import LoadingPage from './../components/UiComponents/LoadingPage';
import { fetchData } from './../actions/init';

class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isDataFetched: false
        }
    }

    componentWillMount() {
        this.props.fetchData();
    }

    componentWillReceiveProps(nextProps) {
        //Check if data has been updated in the store, Using self actor for this
        if (nextProps.uiState.selfActor && !this.state.isDataFetched) {
            this.setState({
                isDataFetched: true
            })
        }
    }

    render() {
        let { isDataFetched } = this.state
        return (
            <Fragment>
                {
                    isDataFetched ?
                        <Router >
                            <Switch>
                                <Route path='/mails/starred' component={MailList} />
                                <Route path='/mails/attachments' component={MailList} />
                                <Route path='/mails/sent' component={MailList} />
                                <Route path='/mails/:id/?:composeType' component={ViewMail} />
                                <Route path='/mails/:id' component={ViewMail} />
                                <Route path='/mails' component={MailList} />
                                {/* <Route path='/gameover' component={LoadableComponent} /> */}
                                {/* <Route path='/welcome' component={Welcome} /> */}
                                <Route path='/tutorial-end' component={TutorialEnd} />
                                <Route path='/tutorial/:id' component={ViewMail} />
                                <Route path='/tutorial' component={Tutorial} />
                                <Route path='/intro-tutorial' component={Intro} />
                                <Route path='/intro/:id' component={Intro} />
                                <Route path='/intro' component={Intro} />
                                <Route path='/welcome' component={Intro} />
                                {/* <Route path='/chat' component={Chat} /> */}
                                <Route exact path='/' component={Intro} />
                            </Switch>
                        </Router>
                        :
                        <LoadingPage />
                }
            </Fragment>
        );
    }
}

const mapStatetoProps = state => {
    return state;
};

export default connect(mapStatetoProps, { fetchData })(App);


// WEBPACK FOOTER //
// /src/routes/AppRouter.js